import store from '../store'

export const authorizeToken = (to, from, next) => {
  window.scrollTo(0, 0)
  const routeGuard = (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
    // マッチしたルートにおいて、メタフィールドに`requiresAuth`が付与されている場合は
    // ログインした際に付与される認証トークンがあるかどうかチェックする
    // 注意:
    // このアプリケーションでは簡略化のため`auth.token`があるかどうかのみで
    // ログイン済みであるかどうかチェックしているが、
    // 本来ならば付与された認証トークンをバックエンドのAPI経由などで検証すべき
      if (!store.state.Auth.user) {
        next({ path: '/Login' })
      } else {
        next()
      }
    } else if ((to.path === '/Login' || to.path === '/') && store.state.Auth.user) {
      next({ path: '/Home' })
    } else {
      next()
    }
  }
  if (!from.name || to.name === 'Login') {
    store.dispatch('Auth/initUser', null)
      .then(output => {
        routeGuard(to, from, next)
      })
  } else {
    routeGuard(to, from, next)
  }
}
